import navigationConstants from '@navigation/navigationConstants';
import { ERROR_CODES, LOGIN_INFO_SHEET_KEYS } from '@root/constants';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatPhoneNumber, formatUnderScoreLowerCase, removeNonNumeric, showErrorBottomSheet } from '@utils/utils';

const authAmplitude = AMPLITUDE_CONSTANTS.authentication;

export function phoneChangeHandler(
  isError: boolean,
  setError: (v: string) => void,
  setPhoneNumber: (v: string) => void,
  setIsDisabled: (v: boolean) => void,
  t: any,
  countryCode: string,
) {
  return (text: string) => {
    if (isError) setError('');
    const numericText = removeNonNumeric(text);
    setPhoneNumber(numericText);

    if (numericText.substring(0, 2) === '00') {
      setIsDisabled(true);
      const e = AMPLITUDE_CONSTANTS.PhoneEnroll.phonenumber_input_error;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.error_message]: formatUnderScoreLowerCase(t('login.invalidNumber')),
      });
      setError(t('login.invalidNumber'));
    }

    if (formatPhoneNumber(numericText, countryCode).length >= 8) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };
}

export function showLoginErrors(
  isError: boolean,
  error: string[],
  setIsLoadingSMS: (v: boolean) => void,
  setIsLoadingWhatsapp: (v: boolean) => void,
  phoneNumber: string,
  setInfoModal: (v: any) => void,
): void {
  if (isError && error) {
    setIsLoadingSMS(false);
    setIsLoadingWhatsapp(false);
    showErrorBottomSheet(setIsLoadingSMS, setIsLoadingWhatsapp, phoneNumber, error[0], setInfoModal);
  }
}

export function shouldNavigateOnSuccess(
  LoginData: any,
  isSuccess: boolean,
  setLoginData: (data: any) => void,
  setIsLoadingSMS: (v: boolean) => void,
  setIsLoadingWhatsapp: (v: boolean) => void,
  navigation: any,
  phoneNumber: string,
): void {
  if (LoginData && isSuccess) {
    const data = LoginData;
    setLoginData(data);
    setIsLoadingSMS(false);
    setIsLoadingWhatsapp(false);
    const e1 = authAmplitude.otp_successful;
    AmplitudeHelper.logEvent(e1.name, {
      [e1.attributes.phone_number]: formatPhoneNumber(phoneNumber),
    });
    navigation.navigate('OTP');
  }
}

export function onPressPrimaryFunction(infoModal: any, phoneNumber: string, setInfoModal: (v: any) => void): void {
  if (infoModal.errorCode === LOGIN_INFO_SHEET_KEYS[ERROR_CODES['GG-OTP-01']]) {
    const e = authAmplitude.login_retry;
    AmplitudeHelper.logEvent(e.name, {
      [e.attributes.phone_number]: formatPhoneNumber(phoneNumber),
    });
  }
  setInfoModal({
    visible: false,
    data: { ...infoModal.data },
    errorCode: infoModal.errorCode,
  });
}

export function onPressSecondaryFunction(
  infoModal: any,
  phoneNumber: string,
  setInfoModal: (v: any) => void,
  setPhoneNumber: (v: string) => void,
  navigation: any,
): void {
  if (infoModal.errorCode === LOGIN_INFO_SHEET_KEYS[ERROR_CODES['GG-OTP-01']]) {
    const e = authAmplitude.login_check_data_clicked;
    AmplitudeHelper.logEvent(e.name, {
      [e.attributes.phone_number]: formatPhoneNumber(phoneNumber),
    });
  }

  setInfoModal({
    visible: false,
    data: { ...infoModal.data },
    errorCode: infoModal.errorCode,
  });
  setPhoneNumber('');

  navigation.navigate(navigationConstants.GG_CHAT_BOT);
}

export function onCloseFunction(infoModal: any, phoneNumber: string, setInfoModal: (v: any) => void): void {
  if (infoModal.errorCode === LOGIN_INFO_SHEET_KEYS[ERROR_CODES['GG-OTP-01']]) {
    const e = authAmplitude.login_modal_closed;
    AmplitudeHelper.logEvent(e.name, {
      [e.attributes.phone_number]: formatPhoneNumber(phoneNumber),
    });
  }
  setInfoModal({ ...infoModal, visible: false });
}
